import angular from 'angular';
import SubscriptionAutoMarketingModal from './subscriptionAutoMarketingModal';
import './style.scss';

export default angular
  .module('components.subscriptionAutoMarketingModal', [])
  .component('subscriptionAutoMarketingModal', SubscriptionAutoMarketingModal)
  .name;
